import React, { Component, Fragment } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import './footer.css';

class Footer extends Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = {};
  }

  render() {
    return (
      <Fragment>
        <footer>
          <div class="container text-center">
            <div class="row footer-top-row">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <nav class="footer">
                  <ul class="footer-left-list">
                    <li>
                      <a href="https://www.haart.co.uk/about-us/contact-us/">Contact us</a>
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/news/">News</a>
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/jargon-buster/">Jargon Buster</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-6">
                <nav class="footer">
                  <ul class="footer-right-list">                	
                    <li>
                      <a href="https://www.haart.co.uk/about-us/">About Us</a>                                       
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/careers/">Careers</a>                                       
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/about-us/legal-information/accessibility/">Accessibility</a>                                       
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/about-us/legal-information/privacy-policy/">Privacy Policy</a>                                       
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/about-us/legal-information/">Legal information</a>                                       
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/sitemap/">Sitemap</a>                                       
                    </li>
                    <li>
                      <a href="https://www.haart.co.uk/media/1625/statement-2018-signed.pdf" target="_blank" title="Link will open in a new window/tab">Modern Slavery Act<i class="ion-android-open after"></i></a>                                       
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-sm-4 col-xs-12 footer-div-left social-container">
                <nav class="social">
                  <ul style={{ paddingLeft: '0px'}}>
                    <li class="twitter"><a href="https://twitter.com/haart_uk?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" class="symbol" target="_blank" title="Link will open in a new window/tab">twitter</a></li>
	            			<li class="facebook"><a href="https://www.facebook.com/haart.estate.agents/" class="symbol" target="_blank" title="Link will open in a new window/tab">facebook</a></li>
	            	    <li class="instagram"><a href="https://www.instagram.com/haartestateagents/" class="symbol" target="_blank" title="Link will open in a new window/tab">instagram</a></li>
	            	  </ul>
                </nav>   
              </div>
              <div class="col-md-3 col-sm-8 col-xs-12 footer-div-left call-us-div">
                <div class="call-us-tel"><a class="phone-link" href="tel:+443458999999">0345 899 9999</a></div>
                <div class="call-us-times">Lines open 8am to 10pm</div>
              </div>
              <div class="col-md-7 col-sm-12 col-xs-12 footer-div-left">
                <nav class="footer-logo-links">
                  <ul style={{ paddingLeft: '0px'}}>    
                    <li><a href="https://www.tpos.co.uk/" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1039/tpo-sales.png" alt="Property Ombudsman-Sales"></img></a></li>
                    <li><a href="https://www.tpos.co.uk/consumers/advice-for-consumers/lettings" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1038/tpo-lettings.png" alt="Property Ombudsman-Lettings"></img></a></li>
                    <li><a href="http://www.arla.co.uk/" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1631/arla-propertymark-protected-white-60px.png" alt="ARLA"></img></a></li>
                    <li><a href="http://www.nalscheme.co.uk/" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1036/nals.png" alt="NALS"></img></a></li>
                    <li><a href="https://www.cyberessentials.ncsc.gov.uk/" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1647/cyber-essentials-badge-white-1.png" alt="Cyber Essentials"></img></a></li>
                    <li><a href="https://www.onthemarket.com/" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1037/on-the-market.png" alt="On The Market"></img></a></li>
                    <li><a href="https://www.tenancydepositscheme.com/" target="_blank"><img class="footer-logo-img" src="https://www.haart.co.uk/media/1703/tds_member_logo-new-white-small.png" alt="TDS Member"></img></a></li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 col-xs-12 footer-div-left footer-text-block">
                <p style={{ lineHeight: '1.4' }}><span class="FooterText">haart is a trading style of Spicerhaart Estate Agents Limited, registered in England and Wales No. 4430​726 and Spicerhaart Residential Lettings Limited, registered in England and Wales No. 0530​4360. Registered Office: Colwyn House, Sheepen Place, Colchester, Essex, CO3 3LD, a Spicerhaart Group Business.</span></p>
                <p style={{ lineHeight: '1.4' }}><span class="FooterText">YOUR HOME MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE. haart introduce to Just Mortgages a trading name of Just Mortgages Direct Limited who are appointed representatives of Openwork Limited who are authorised and regulated by the Financial Conduct Authority..</span></p>
              </div>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }
}

export default Footer;